module.exports = require("@angular-devkit/architect");